import { DRAFT_MESSAGE_THREAD_ID_PREFIX } from 'Domains/Messages/constants';

export default function isThreadDraft(id: string) {
  return id.indexOf(DRAFT_MESSAGE_THREAD_ID_PREFIX) === 0;
}
